import apiClient from '../client';
import ENDPOINTS from '../endpoints';

/* One email attachment → the backend, which checks the type and size again
   and puts the file on S3. The reply says where it landed; the sent-email
   record keeps that so Previous Emails can list the files later. The bytes
   themselves still travel with the email, out of the browser through Gmail. */
const attachmentsService = {
  upload: async ({ networkId, file, onProgress, signal }) => {
    const fd = new FormData();
    fd.append('networkId', networkId);
    fd.append('file', file, file.name);
    const res = await apiClient.post(ENDPOINTS.ROOM_PARENT_ADMIN.EMAIL_ATTACHMENT, fd, {
      signal,
      /* 25 MB over a slow link takes longer than the client's 30 s default */
      timeout: 5 * 60 * 1000,
      onUploadProgress: (e) => {
        /* 99 until the server has answered — the file isn't there yet */
        if (onProgress && e.total) onProgress(Math.min(99, Math.round((100 * e.loaded) / e.total)));
      },
    });
    const data = res?.data ?? res;
    const a = data?.data || data;
    return {
      url: a?.url || '',
      key: a?.key || '',
      name: a?.name || file.name,
      size: Number(a?.size ?? file.size),
      contentType: a?.contentType || file.type || '',
      kind: a?.kind || '',
      label: a?.label || '',
    };
  },
};

export default attachmentsService;
